import { useAuth } from '../../store/auth'

export const useMe = () => {
  const { authUser } = useAuth()
  return authUser
}
